import { render, staticRenderFns } from "./SessionListItem.vue?vue&type=template&id=5e5515be&scoped=true&"
import script from "./SessionListItem.vue?vue&type=script&lang=js&"
export * from "./SessionListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5515be",
  null
  
)

export default component.exports